import { render, staticRenderFns } from "./a-svg-progress.vue?vue&type=template&id=48c1ebfe&scoped=true"
import script from "./a-svg-progress.vue?vue&type=script&lang=js"
export * from "./a-svg-progress.vue?vue&type=script&lang=js"
import style0 from "./a-svg-progress.vue?vue&type=style&index=0&id=48c1ebfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c1ebfe",
  null
  
)

export default component.exports